import { Link } from 'react-router-dom'
import s from './DealProposals.scss'

const DealProposals = ({ proposals }) => (
  <section className={s.dealProposals}>
    {proposals.map(proposal => (
      <Link key={proposal.id} to={`/proposals/${proposal.id}`}>
        {proposal.name}
      </Link>
    ))}
  </section>
)

export default DealProposals
